import { render, staticRenderFns } from "./TkHotelPlanCard.vue?vue&type=template&id=9d6fea7e&"
import script from "./TkHotelPlanCard.vue?vue&type=script&lang=js&"
export * from "./TkHotelPlanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports